import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["existingSearch", "existingSelect", "newFields", "optionalFields", "optionalToggle", "newOnly"]
 


  existingChanged() {
    this.applyExistingSelection()
  }

  toggleOptional() {
    const show = this.optionalToggleTarget.checked
    this.optionalFieldsTarget.style.display = show ? "" : "none"
  }


  filterExistingPeople() {
  const searchInput = this.existingSearchTarget
  const select = this.existingSelectTarget
  const query = searchInput.value.trim().toLowerCase()
  const status = this.hasSearchStatusTarget ? this.searchStatusTarget : null

  let visibleMatches = []

  Array.from(select.options).forEach((option, index) => {
    if (index === 0 || option.value === "") {
      option.hidden = false
      option.selected = false
      return
    }

    const searchText = option.dataset.searchText || ""
    const isMatch = query.length > 0 && searchText.includes(query)

    option.hidden = !isMatch
    option.selected = false

    if (isMatch) {
      visibleMatches.push(option)
    }
  })

 if (visibleMatches.length === 1) {
  const onlyMatch = visibleMatches[0]
  onlyMatch.hidden = false
  onlyMatch.selected = true
  select.value = onlyMatch.value

  if (status) {
    status.textContent = "1 match found — selected automatically"
  }

} else if (visibleMatches.length > 1) {
  select.selectedIndex = 0
  select.value = ""

  if (status) {
    status.textContent = `${visibleMatches.length} matches found — please select one`
  }

} else if (query.length > 0) {
  select.selectedIndex = 0
  select.value = ""

  if (status) {
    status.textContent = "No matches — a new person will be created"
  }

} else {
  select.selectedIndex = 0
  select.value = ""

  if (status) {
    status.textContent = ""
  }
}
select.dispatchEvent(new Event("change", { bubbles: true }))
}


  applyExistingSelection() {
      if (!this.hasExistingSelectTarget) return
      const existingId = (this.existingSelectTarget.value || "").trim()
      const usingExisting = existingId.length > 0

    // Hide new-person fields entirely when using an existing person
    this.newFieldsTarget.style.display = usingExisting ? "none" : ""

    // Disable new-only inputs so Rails receives nothing from them
    this.newOnlyTargets.forEach((el) => {
      el.disabled = usingExisting
    })

    // Also collapse optional details when switching to existing person
    if (usingExisting && this.hasOptionalFieldsTarget) {
      this.optionalFieldsTarget.style.display = "none"
    }
    if (usingExisting && this.hasOptionalToggleTarget) {
      this.optionalToggleTarget.checked = false
    }
  }
}
